import { api } from "@/lib/api";
import type { AdSourceDto, PageResponse } from "@/types/api";

export interface AdSourceListParams {
    page?: number;
    size?: number;
    sort?: string;
    /** Affiliate filter. -1 means "IS NULL" (unassigned). */
    affiliateId?: number;
}

export interface CreateAdSourceRequest {
    slug: string;
    label: string;
    clickIdParams: string[];
    enabled?: boolean;
    notes?: string | null;
}

export interface UpdateAdSourceRequest {
    label?: string | null;
    clickIdParams?: string[] | null;
    enabled?: boolean | null;
    notes?: string | null;
}

export async function listAdSourcesPaged(params: AdSourceListParams = {}): Promise<PageResponse<AdSourceDto>> {
    const q: Record<string, string | number> = {};
    if (params.page != null) q.page = params.page;
    if (params.size != null) q.size = params.size;
    if (params.sort) q.sort = params.sort;
    if (params.affiliateId != null) q.affiliateId = params.affiliateId;
    const { data } = await api.get<PageResponse<AdSourceDto>>("/admin/ad-sources", { params: q });
    return data;
}

export async function listAdSources(enabledOnly = false): Promise<AdSourceDto[]> {
    // enabledOnly returns a flat array (used by dropdown pickers); everything
    // else uses the paginated variant and we unwrap .content for back-compat.
    if (enabledOnly) {
        const { data } = await api.get<AdSourceDto[]>("/admin/ad-sources", { params: { enabledOnly: true } });
        return data;
    }
    const page = await listAdSourcesPaged({ size: 1000 });
    return page.content;
}

export async function createAdSource(request: CreateAdSourceRequest): Promise<AdSourceDto> {
    const { data } = await api.post<AdSourceDto>("/admin/ad-sources", request);
    return data;
}

export async function updateAdSource(id: number, request: UpdateAdSourceRequest): Promise<AdSourceDto> {
    const { data } = await api.patch<AdSourceDto>(`/admin/ad-sources/${id}`, request);
    return data;
}

export async function deleteAdSource(id: number): Promise<void> {
    await api.delete(`/admin/ad-sources/${id}`);
}
